<div class="consent-sheet">
  <div class="consent-icon">
    <ion-icon name="shield-checkmark-outline"></ion-icon>
  </div>

  <div class="consent-body">
    <h2>Darf Melowish messen, was funktioniert?</h2>

    <p class="consent-text">
      Wir würden gern speichern, über welchen Kanal du zu uns gefunden hast. Das
      hilft uns zu erkennen, welche Songs und welche Ansprache ankommen und
      führt dazu, dass wir weniger Geld für schlechte Werbung verbrennen. Was dort
      übrig bleibt, steckt am Ende in der Musik statt in Werbeanzeigen.
    </p>

    <ul class="consent-list">
      <li>
        <ion-icon name="checkmark-circle" color="success"></ion-icon>
        <span>
          <strong>Immer aktiv:</strong> alles, was zum Erstellen und Anhören
          deines Songs nötig ist
        </span>
      </li>
      <li>
        <ion-icon name="help-circle-outline"></ion-icon>
        <span>
          <strong>Nur mit deiner Zustimmung:</strong> die Herkunft deines Besuchs
          über die Sitzung hinaus und Messung über Meta. Es werden keine Daten verkauft.
        </span>
      </li>
    </ul>

    <div class="consent-actions">
      <!-- secondaryBtn ist die Sekundaeraktion des Projekts: getoenter
           Hintergrund, Primaerfarbe als Schrift. Bewusst kein Outline-Button -
           global setzt ion-button --color mit !important auf weiss, dadurch war
           die Beschriftung unsichtbar. Zwei gefuellte Buttons sind ausserdem
           optisch gleichwertiger, was bei einer Einwilligung Pflicht ist. -->
      <ion-button
        expand="block"
        class="secondaryBtn"
        (click)="acceptNecessary()"
      >
        Ablehnen
      </ion-button>

      <ion-button expand="block" class="primaryBtn" (click)="acceptAll()">
        Akzeptieren
      </ion-button>
    </div>

    <button type="button" class="consent-link" (click)="openPrivacy()">
      Datenschutzerklärung
    </button>

    <p class="consent-note">
      Du kannst deine Entscheidung jederzeit in den Einstellungen ändern.
    </p>
  </div>
</div>
